var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7873 21.5C10.3523 21.5 9.9447 21.4022 9.56463 21.2066C9.18455 21.011 8.87244 20.7317 8.62829 20.3687L3.64527 12.9271C3.53197 12.751 3.48495 12.5616 3.50419 12.359C3.52344 12.1563 3.61434 11.9844 3.7769 11.8433C4.06292 11.5751 4.39766 11.419 4.78112 11.375C5.16458 11.331 5.52873 11.4283 5.87355 11.667L8.12952 13.2249V5.14681C8.12952 4.89001 8.21773 4.6737 8.39415 4.49788C8.57055 4.32208 8.78761 4.23417 9.04531 4.23417C9.30301 4.23417 9.52006 4.32208 9.69647 4.49788C9.87289 4.6737 9.9611 4.89001 9.9611 5.14681V12.0835H11.5641V3.41264C11.5641 3.15583 11.6523 2.93952 11.8287 2.7637C12.0051 2.5879 12.2221 2.5 12.4798 2.5C12.7375 2.5 12.9546 2.5879 13.131 2.7637C13.3074 2.93952 13.3956 3.15583 13.3956 3.41264V12.0835H14.9986V4.28985C14.9986 4.03304 15.0868 3.81673 15.2632 3.64092C15.4396 3.4651 15.6567 3.3772 15.9144 3.3772C16.1721 3.3772 16.3891 3.4651 16.5655 3.64092C16.742 3.81673 16.8302 4.03304 16.8302 4.28985V12.0835H18.4331V5.98353C18.4331 5.72671 18.5213 5.5104 18.6978 5.3346C18.8742 5.15878 19.0912 5.07087 19.3489 5.07087C19.6066 5.07087 19.8237 5.15878 20.0001 5.3346C20.1765 5.5104 20.2647 5.72671 20.2647 5.98353V18.0468C20.2647 18.9986 19.926 19.8121 19.2485 20.4872C18.571 21.1624 17.7547 21.5 16.7997 21.5H10.7873V21.5Z",
    fill: "#4C4948"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.478cf19c6d676a0be1c0fe86abc4caa6.svg";
export { ForwardRef as ReactComponent };